/**
 * ISSUE-1366. The web composer's emoji picker, after v1's
 * `emoji_select_sheet.dart`. It renders through the shared `Dialog`, so it is
 * a bottom sheet under 768px and a centered dialog above
 * (`responsive-overlays.mdc`).
 *
 * The sheet stays open after a tap, so a fan can add several emoji in a row
 * the way they would from a keyboard, then close it. Each tap goes up to
 * the composer, which inserts at the caret it saved when the sheet opened.
 */
import { Dialog, FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { COMPOSER_EMOJI_TITLE } from "./chatExtrasCopy";
import { COMPOSER_EMOJI_GROUPS } from "./composerEmojiLogic";

export const EmojiPickerSheet = ({
  open,
  onOpenChange,
  onSelect,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (emoji: string) => void;
}): ReactNode => (
  <Dialog
    open={open}
    onOpenChange={onOpenChange}
    title={COMPOSER_EMOJI_TITLE}
    autoFocus={false}
  >
    <div className="flex flex-col gap-4" data-testid="composer-emoji-picker">
      {COMPOSER_EMOJI_GROUPS.map((group) => (
        <section key={group.key} className="flex flex-col gap-1">
          <h3 className="text-caption text-ink-secondary">{group.label}</h3>
          <div className="grid grid-cols-6 md:grid-cols-8">
            {group.emoji.map((emoji) => (
              <button
                key={emoji}
                type="button"
                aria-label={emoji}
                data-testid="composer-emoji-option"
                onClick={() => {
                  onSelect(emoji);
                }}
                className={`flex min-h-touch-target min-w-touch-target items-center justify-center rounded-md text-h2 hover:bg-surface-secondary ${FOCUS_RING}`}
              >
                {emoji}
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  </Dialog>
);
